import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { API_BASE_URL } from '../tokens/api-base-url';
import { isNuestroApiUrl } from '../utils/api-url.util';
import { isPublicAuthApiUrl } from '../utils/public-auth-url';

/** Evita múltiples redirecciones si varias peticiones llegan con 401 al mismo tiempo. */
let redirectingToLogin = false;

/** Sesión inválida/expirada: limpia token y vuelve al login (solo nuestro API). */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const apiBase = inject(API_BASE_URL);

  return next(req).pipe(
    catchError((err: unknown) => {
      const skipLogout =
        isPublicAuthApiUrl(req.url) ||
        req.url.includes('/auth/login') ||
        !isNuestroApiUrl(req.url, apiBase);

      if (err instanceof HttpErrorResponse && err.status === 401 && !skipLogout) {
        if (!redirectingToLogin) {
          redirectingToLogin = true;
          const returnUrl = router.url.startsWith('/app') ? router.url : undefined;
          auth.logout();
          void router
            .navigate(['/login'], {
              queryParams: {
                sesion: 'expirada',
                ...(returnUrl ? { returnUrl } : {}),
              },
            })
            .then(() => {
              setTimeout(() => {
                redirectingToLogin = false;
              }, 2000);
            });
        }
      }
      return throwError(() => err);
    }),
  );
};
